import React from "react";
import {StyleImageButton} from "components/Common/StyleButton";
import {StyleDiv} from "components/Common/StyleDiv";
import {StyleLink} from "components/Common/StyleLink";
import {WATERSPEED_APP_STORE_LINK, WATERSPEED_PLAY_STORE_LINK} from "constants/AppConstants.js";

function DownloadOnTheAppStoreButton() {
  return (
    <StyleDiv margin="40px 0px 0px 0px">
      <StyleLink to={{pathname: WATERSPEED_PLAY_STORE_LINK}} target="_blank" margin="0px 20px 0px 0px">
        <StyleImageButton
          alt="download-on-the-play-store-button"
          src={`/assets/icons/download-playstore.png`}
          width={140}
          height={40}
        />
      </StyleLink>
      <StyleLink to={{pathname: WATERSPEED_APP_STORE_LINK}} target="_blank">
        <StyleImageButton
          height={40}
          alt="download-on-the-app-store-button"
          src={`/assets/icons/icon-download-on-the-app-store-badge.svg`}
        />
      </StyleLink>
    </StyleDiv>
  );
}

export default DownloadOnTheAppStoreButton;
